import {typeTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = typeTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const typeReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default typeReducer;
